import service from '../utils/request'
// 根据ID获取详情
export const getrolebyid = params => {return service.get(`/api/base_employee_role/get`, {params: params})};
// 查询列表
export  const queryrole = params => {return service.post(`/api/base_employee_role/query`, params)};
// 创建角色
export const createrole = params => {return service.post(`/api/base_employee_role/create`, params)};
// 获取权限树
export const employeeroletree = params => {return service.get(`/api/base_employee_role/employeeroletree`, {params})};
// 修改员工
export const editrole = params => {return service.put(`/api/base_employee_role/edit`, params)};
// 删除员工
export const deleterole = params => {return service.delete(`/api/base_employee_role/delete`, {params})};
